import { useScreenSize } from './useScreenSize';

const desktopScreenWidthPixels = 769;

export const useDetectMobileScreenWidth = (): boolean => {
  const screenSize = useScreenSize();

  return desktopScreenWidthPixels >= screenSize.width;
};
